<template>
  <div>
    <Card
      title="Create Playlist"
    >
      <template v-slot:button>
        <Button  @clicked="goBack" variant="default" label="Cancel" />
        <Button @clicked="submit" variant="primary" label="Save" />
      </template>
      <template v-slot:body>
        <div class="flex flex-col">
          <h5 class="text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left">
            Playlist Form
          </h5>
          <div class="flex flex-col items-center mb-6">
            <div class="px-4 mb-6">
              <img
                alt="..."
                class="shadow rounded max-w-full h-auto align-middle border-none"
                :src="cover?cover:imgPlaceholder"
                style="width: 150px;"
              />
            </div>
            <div class="flex flex-col mb-2">
              <p class="text-xs text-gray-700">Minimum 900x900, Maximum 1MB</p>
            </div>
            <div class="flex flex-col mb-2" v-if="isFileLarge || isErrorImage">
              <text-error v-if="isFileLarge" text="Please select correct file" />
              <text-error v-if="isErrorImage" text="Please select image cover" />
            </div>
            <div class="flex">
              <Button label="Browse File" v-if="!cover">
                <template v-slot:any>
                  <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                         type="file"
                         name="profile_picture"
                         @change="onFileChange"
                  />
                </template>
              </Button>
              <Button label="Cancel" variant="default" v-if="cover" @clicked="changeImage"></Button>
            </div>
          </div>
          <form-item label='Playlist Name'>
            <template v-slot>
              <Input
                v-model="name"
                placeholder="Number of Songs"
                :error="($v.name.$dirty && !$v.name.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.name.$dirty && !$v.name.required"
                  text="Please fill Playlist Name."
                >
                </text-error>
              </div>
            </template>
          </form-item>
        </div>
        <div class="flex flex-col border-b border-gray-200 py-3">
          <div class="flex justify-between">
            <h5 class="text-gray-700 text-sm py-2 font-bold uppercase">
              Song List
            </h5>
            <Button variant="outline-primary" label="Add Song" @clicked="showModal" />
          </div>
          <text-error v-if="isSongEmpty" text="Song cannot be empty" />
        </div>
        <el-table-draggable  handle=".handle-move"  v-if="dataSong.length > 0" >
          <el-table :data="dataSong" row-key="id" :show-header="false" style="width: 100%">
            <el-table-column label="Handle" align="center" key="handle">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column v-for="column in tableSongColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Song" width="250px" >
              <template slot-scope="scope">
                <audio controls :src="scope.row.preview_file_data" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
                  Audio tag not supported
                </audio>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="removeFromList(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
        <div class="flex justify-center py-6 text-sm" v-if="dataSong.length === 0">
          No song added. Please add a song to continue
        </div>
      </template>
    </Card>
    <ModalDialog
      size="large"
      ref="addSong"
      :isShowingModal="isShowingModal"
      title="Add Song"
      @toggleModal="isShowingModal = !isShowingModal"
      :labelSubmit="'Submit'"
      @save="submitAddSong()" >
      <template slot="body" >
        <SearchSong ref="addSongContent"  @on-submit-song="addSongPlaylist" :toggle-reset="isShowingModal"  :taken-song="dataSong"></SearchSong>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import ElTableDraggable from 'el-table-draggable';
import axios from 'axios';
import Card from '@/components/Layout/Card';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import SearchSong from './SearchSong';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

const API_URL = process.env.API_URL;
export default {
  name: 'AddPlaylist',
  mixins: [validationMixin],
  data: () => ({
    name: '',
    cover: null,
    imageErrorMessage: '',
    isFileLarge: false,
    isShowingModal: false,
    isSongEmpty: false,
    dataSong: [],
    takenSong: [],
    tableSongColumn: [
      {
        prop: 'title',
        label: 'Song Name',
      },
      {
        prop: 'album',
        label: 'Album',
      },
      {
        prop: 'artist',
        label: 'Artist',
      },
    ],
    imgPlaceholder
  }),
  validations: {
    name: {
      required,
    },
  },
  computed: {
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
    isErrorImage() {
      return this.imageErrorMessage.length > 0;
    },
  },
  methods: {
    ...mapActions('PlaylistModule', ['requestCreatePlaylist']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    async submit() {
      this.$v.$touch();
      this.imageErrorMessage = this.cover == null ? 'Select Cover' : '';
      this.isSongEmpty = this.checkSongEmpty();
      const isValid = !this.$v.$invalid && !this.isSongEmpty && this.imageErrorMessage.length === 0 && !this.isFileLarge;
      if (isValid) {
        const resultImage = await axios({
          method: 'get',
          url: this.cover,
          responseType: 'blob',
        }).then(this.processFileBlob);
        const songList = this.dataSong.map(play => play.id);
        const playlist = {
          title: this.name,
          cover: resultImage,
          song: songList,
        };
        await this.requestCreatePlaylist(playlist);
        this.$router.push({ name: 'ListPlaylist' });
      }
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.imageErrorMessage = '';
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.cover = URL.createObjectURL(file);
    },
    changeImage() {
      this.cover = null;
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
        headers: {
          Authorization: `${this.tokenType} ${this.accessToken}`,
        },
      });
      return fileAudio.data;
    },
    submitAddSong() {
      this.$refs.addSongContent.submit();
    },
    async addSongPlaylist(data) {
      this.isShowingModal = false;
      if (data.length > 0) {
        this.setLoading();
        this.dataSong = await Promise.all(data.map(async (song) => {
          const preview_file_data = await this.getMusicFile(song.file);
          return Object.assign(
            {},
            song,
            {
              preview_file_data,
            },
          );
        }));
        this.unsetLoading();
      } else {
        this.dataSong = [];
      }
      this.isSongEmpty = this.checkSongEmpty();
      this.isShowingModal = false;
    },
    removeFromList(row) {
      const index = this.dataSong.findIndex(song => song.id === row.id);
      this.dataSong.splice(index, 1);
      this.isSongEmpty = this.checkSongEmpty();
    },
    checkSongEmpty() {
      return this.dataSong.length === 0;
    },
    goBack() {
      this.$router.push({ name: 'ListPlaylist' });
    },
    showModal() {
      this.isShowingModal = true;
    },
  },
  components: { ModalDialog,
    VueCustomTooltip,
    SearchSong,
    ElTableDraggable,
    Card,
    FormItem,
    Input,
    TextArea,
    Button,
    TextError,
    Select,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Playlist/Add.vue